<button class="logout-button" [ngClass]="variant" (click)="logout()">
  <span class="icon"><i class="fa-solid fa-arrow-right-from-bracket"></i></span>
</button>
